// iPhone/iPad (Q-040): 16px dan kichik yozish maydoniga bosilganda Safari sahifani o'zi yaqinlashtiradi
// va qaytarmaydi — ekran "kattalashib", chetlari kesilib qoladi. iOS'da `maximum-scale=1` faqat shu
// avtomatik yaqinlashtirishni to'xtatadi; barmoq bilan kattalashtirish ishlayveradi (iOS 10+).
// Android'da bu qo'yilmaydi — u yerda barmoq bilan kattalashtirishni o'chirib qo'yardi.

/** iPhone, iPod yoki iPad (iPadOS o'zini Mac deb ko'rsatadi — sensor nuqtalari bilan ajratamiz) */
export function isIos(ua: string, platform: string, touchPoints: number): boolean {
  if (/iPhone|iPad|iPod/i.test(ua) || /iPhone|iPad|iPod/i.test(platform)) return true;
  return platform === 'MacIntel' && touchPoints > 1;
}

/** Viewport'ga maximum-scale=1 qo'shadi (faqat iOS). Qayta chaqirilsa ham bir marta. */
export function preventIosInputZoom(doc: Document = document, nav: Navigator = navigator): boolean {
  if (!isIos(nav.userAgent ?? '', nav.platform ?? '', nav.maxTouchPoints ?? 0)) return false;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return false;
  const content = meta.getAttribute('content') ?? '';
  if (!/maximum-scale/i.test(content)) meta.setAttribute('content', `${content}, maximum-scale=1`);
  return true;
}
